<div>
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="Supplier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Supplier</th>
      <td mat-cell *matCellDef="let row">
        {{row.CompanyName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="DocumentNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Number</th>
      <td mat-cell *matCellDef="let row">
        {{row.DocumentNumber}}
      </td>
    </ng-container>
        
    <ng-container matColumnDef="Currency">
      <th mat-header-cell *matHeaderCellDef>Currency</th>
      <td mat-cell *matCellDef="let row">
        {{row.Currency.Code}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
      <td mat-cell *matCellDef="let row">
        {{row.Date | date: 'd MMM yyyy'}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Goods">
      <th mat-header-cell *matHeaderCellDef>Goods</th>
      <td mat-cell *matCellDef="let row">
        {{row.Goods | currency: row.Currency.Code}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Freight">
      <th mat-header-cell *matHeaderCellDef>Freight</th>
      <td mat-cell *matCellDef="let row">
        {{row.Freight | currency: row.Currency.Code}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Tax">
      <th mat-header-cell *matHeaderCellDef>Tax</th>
      <td mat-cell *matCellDef="let row">
        {{row.Tax | currency: row.Currency.Code}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let row">
        {{row.Total | currency: row.Currency.Code}}
      </td>
    </ng-container>

    <ng-container matColumnDef="MissingVAT">
      <th mat-header-cell *matHeaderCellDef>Missing VAT</th>
      <td mat-cell *matCellDef="let row">
        <input type="checkbox" [checked]="row.MissingVAT" disabled>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="Added">
      <th mat-header-cell *matHeaderCellDef>Added</th>
      <td mat-cell *matCellDef="let row">
        {{row.Added | date: 'd MMM yyyy'}}
      </td>
    </ng-container>
    
    <ng-container matColumnDef="AddedBy">
      <th mat-header-cell *matHeaderCellDef>Added By</th>
      <td mat-cell *matCellDef="let row">
        {{row.AddedBy}}
      </td>
    </ng-container>

    <ng-container matColumnDef="View">
      <th mat-header-cell *matHeaderCellDef>View</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button [attr.invoice-number]="row.DocumentNumber" [attr.is-credit]="row.Total < 0" onclick="showInvoice(this, event)" (click)="row.Viewed=true">
          <mat-icon>visibility</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let row">
        <button *ngIf="row.Viewed" mat-icon-button (click)="tryCheck(row)">
          <mat-icon>check</mat-icon>
        </button>
        <button *ngIf="row.Viewed" mat-icon-button (click)="tryEdit(row)">
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="row.Viewed" mat-icon-button (click)="tryDelete(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="dataColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
  </table>
</div>
